import { toastr } from 'react-redux-toastr';
import { reset } from 'redux-form';

export const sendContact = payload => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const user = getState().firebase.profile;

    //console.log(payload);
    let newPayload = { ...payload };

    if (payload.email && payload.name) {
      //console.log('trigger');
      newPayload.sender = payload.name;
      newPayload.date = new Date().toISOString();
      newPayload.from = payload.email;
      newPayload.sender_id = 'general';
      newPayload.received_from = 'user';
    }

    if (user.email) {
      //console.log('trigger2');
      newPayload.sender = user.displayName;
      newPayload.date = new Date().toISOString();
      newPayload.from = user.email;
      newPayload.sender_id = user.uid;
      newPayload.received_from = 'user';
    }

    if (newPayload.from) {
      try {
        await firebase
          .push(`contactMessages`, newPayload)
          .then(() => {
            dispatch(reset('contactForm'));
            toastr.success('Success', 'Contact message was sent');
          })
          .catch(error => {
            console.error(error);
            toastr.error(
              'Failed',
              'Contact message was  not sent. ' + error.message
            );
          });
      } catch (error) {
        console.error(error);
        toastr.error('Failed', 'Contact message was  not sent. ' + error);
      }
    }
  };
};
